export default __webpack_public_path__ + "static/Activity-4x3-S_Swim-2163234b690879138c17e80c6600cad2.png";